export default __webpack_public_path__ + "static/media/pg.078819a2.svg";